// @ts-expect-error not typed
import { updateThemeVariantName } from 'ContentEditorUI/redux/actions/themeActions';
import { selectIsUngatedForThemeSettingsVariant } from '../../auth/selectors/auth';
import { FETCH_KB_CATEGORIES_FAILED, FETCH_KB_CATEGORIES_SUCCESS, FETCH_KB_FAILED, FETCH_KB_SUCCESS } from '../../editor/actions/ActionTypes';
import * as kbApi from '../api/knowledgeBasesApi';
export function fetchKnowledgeBase(groupId) {
  return (dispatch, getState) => {
    kbApi.getKnowledgeBase(groupId).then(payload => {
      dispatch({
        type: FETCH_KB_SUCCESS,
        payload
      });
      setTimeout(() => {
        dispatch(updateThemeVariantName(selectIsUngatedForThemeSettingsVariant(getState()) ? payload.values.hs_id : payload.values.hs_theme_settings_id));
      }, 2000);
    }).catch(error => {
      dispatch({
        type: FETCH_KB_FAILED,
        error
      });
    });
  };
}
export function fetchKnowledgeBaseCategories() {
  return dispatch => {
    kbApi.getCategories().then(payload => {
      dispatch({
        type: FETCH_KB_CATEGORIES_SUCCESS,
        payload
      });
    }).catch(error => {
      dispatch({
        type: FETCH_KB_CATEGORIES_FAILED,
        error
      });
    });
  };
}